import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Breadcrumbs from "../based/Breadcrumbs";
import { INITPAGING, NOTIFY } from "../based/Constants";
import Common from "../based/Common";
import CommonTable from "../based/CommonTable";
import Loading from "../based/Loading";
import PartnerModal from "./PartnerModal";
import PartnerServices from "../based/services/PartnerServices";
import { Notify } from "../based/Notify";
import { useHistory } from "react-router-dom";

function PartnerManagement(props) {
    const [isBusy, setIsBusy] = useState(false);
    const [datas, setDatas] = useState([]);
    const [paging, setPaging] = useState({ ...INITPAGING });
    const [showModal, setShowModal] = useState(false);
    const history = useHistory();

    useEffect(() => {
        getPartners(paging);
    }, []);

    const getPartners = async (page) => {
        setIsBusy(true);
        const [err, data] = await PartnerServices.GetPartnerUserModel(page);
        if (!err && data) {
            setDatas(data.listObjects);
            setPaging(data.paging);
        } else {
            setDatas([]);
            setPaging(page);
        }
        setIsBusy(false);
    };

    const removePartner = async (userId) => {
        const [err, data] = await PartnerServices.DeletePartner(userId);
        if (!err && data) {
            Notify(NOTIFY.SUCCESS, "Thành công", "Xóa partner thành công");
            getPartners(paging);
        } else {
            Notify(NOTIFY.ERROR, "Lỗi", "Xóa partner thất bại");
        }
    };

    function renderAction() {
        return (
            <div className="form-row">
                <button
                    className="btn btn-custom"
                    onClick={(e) => {
                        setShowModal(true);
                    }}
                >
                    Thêm Partner
                </button>
            </div>
        );
    }

    function renderHeader() {
        return (
            <thead>
                <tr>
                    <th>STT</th>
                    <th>Tên Partner</th>
                    <th>Gmail</th>
                    <th>Doanh thu</th>
                    <th>Lợi nhuận gộp</th>
                    <th></th>
                </tr>
            </thead>
        );
    }

    function renderBody() {
        return (
            <tbody>
                {datas && datas.length > 0 ? (
                    datas.map((item, index) => {
                        return (
                            <tr>
                                <td className="vertical-middle">{index + 1}</td>
                                <td className="vertical-middle">{item.fullName}</td>
                                <td className="vertical-middle">{item.userName}</td>
                                <td className="vertical-middle">{Common.formatCurrency(0)}</td>
                                <td className="vertical-middle">{Common.formatCurrency(0)}</td>
                                <td>
                                    <div className="list-action-row">
                                        <button
                                            className="btn btn-custom m-2"
                                            onClick={(e) => {
                                                history.push(`/edit-partner/${item.id}`);
                                            }}
                                        >
                                            Chi tiết
                                        </button>
                                        <button
                                            className="btn btn-danger m-2"
                                            onClick={(e) => {
                                                removePartner(item.id);
                                            }}
                                        >
                                            Xóa
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        );
                    })
                ) : (
                    <tr>
                        <td colSpan="6" className="text-center">
                            Không có dữ liệu
                        </td>
                    </tr>
                )}
            </tbody>
        );
    }

    return (
        <React.Fragment>
            <Loading show={isBusy} msg={"Đang tải dữ liệu..."} />
            <Wrapper>
                <CommonTable paging={paging} renderAction={renderAction} renderHeader={renderHeader} renderBody={renderBody} onFilter={(paging) => {}} />
            </Wrapper>
            <PartnerModal
                show={showModal}
                onClose={() => {
                    setShowModal(false);
                }}
                onSave={() => {
                    getPartners({ ...paging, pageNumber: 1 });
                    setShowModal(false);
                }}
            />
        </React.Fragment>
    );
}

export default PartnerManagement;

const Wrapper = styled.div`
    .form-row {
        margin: 12px 0;
    }

    .list-action-row button {
        margin: 6px;
    }
`;
